<form [formGroup]="form">
  <mat-card>
    <mat-card-content>
      <div class="row gx-2">
        <div class="col-lg-2 col-md-3 col-sm-6 col-12 mb-2">
          <mat-form-field class="w-100">
            <mat-label>Nro. Comprobante</mat-label>
            <input formControlName="NumeroComprobante" matInput>
          </mat-form-field>
        </div>

        <div class="col-lg-3 col-md-4 col-sm-6 col-12 mb-2">
          <mat-form-field class="w-100">
            <mat-label>Rango de fechas</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate [disabled]="true" formControlName="FechaDesde" placeholder="Desde" />
              <input matEndDate [disabled]="true" formControlName="FechaHasta" placeholder="Hasta" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
          </mat-form-field>
        </div>

        <div class="col-lg-2 col-md-3 col-sm-6 col-12 mb-2">
          <mat-form-field class="w-100">
            <mat-label>Rangos rápidos</mat-label>
            <mat-select formControlName="RangoFecha" (selectionChange)="selectRangoFecha($event)">
              <mat-option [value]="fecha.id" *ngFor="let fecha of lstRangoFecha;let i=index;trackBy:trackByItems">
                {{ fecha.descripcion | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-2 col-md-3 col-sm-6 col-12 mb-2" *ngIf="checkedFiltroAvanzado">
          <mat-form-field class="w-100">
            <ngx-spinner [zIndex]="100" name="spBusquedaTiposComprobantes" bdColor="rgba(255,255,255,0.8)"
              size="small" color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Tipo Comprobante</mat-label>
            <mat-select formControlName="TiposComprobantes">
              <mat-option [value]="tipoComprobante.id"
                *ngFor="let tipoComprobante of lstTiposComprobantes;let i=index;trackBy:trackByItems">
                {{ tipoComprobante.descripcion | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-2 col-md-3 col-sm-6 col-12 mb-2" *ngIf="checkedFiltroAvanzado">
          <mat-form-field class="w-100">
            <ngx-spinner [zIndex]="100" name="spBusquedaEstadosComprobante" bdColor="rgba(255,255,255,0.8)"
              size="small" color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Estado</mat-label>
            <mat-select formControlName="EstadosComprobante">
              <mat-option [value]="estadoComprobante.id"
                *ngFor="let estadoComprobante of lstEstadosComprobante;let i=index;trackBy:trackByItems">
                {{ estadoComprobante.descripcion | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row gx-1" *ngIf="checkedFiltroAvanzado">
        <div class="col-lg-3 col-md-4 col-sm-6 col-12 mb-2">
          <app-buscar-contrato (eventEntity)="selectContrato($event)"></app-buscar-contrato>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 col-12 mb-2">
          <app-buscar-propiedad (eventEntity)="selectPropiedad($event)"></app-buscar-propiedad>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 col-12 mb-2">
          <app-buscar-persona-inquilino (eventEntity)="selectInquilino($event)"></app-buscar-persona-inquilino>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 d-flex flex-wrap align-items-center">
          <button mat-stroked-button color="primary" (click)="buscarComprobantes()">
            <mat-icon>filter_alt</mat-icon>
            Filtrar
          </button>

          <mat-slide-toggle class="mx-3" (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>

          <button mat-stroked-button color="primary" *ngIf="checkedFiltroAvanzado" (click)="clearForm()">
            <mat-icon>clear_all</mat-icon>
            Limpiar
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</form>
